import CookiesBanner from './CookiesBanner';
import CookiesBannerContainer from './CookiesBanner.container';
export default CookiesBannerContainer(CookiesBanner);
